/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQueryClient } from '@tanstack/react-query'

export type QueryKey = [string] | [string, { [key: string]: any }]
type GetQueryType = <T>(queryKey: QueryKey, defaultValue?: any) => T

export const useGetQueryState: GetQueryType = (queryKey, defaultValue) => {
  const queryClient = useQueryClient()
  const state = queryClient.getQueryState(queryKey)
  return state?.data || defaultValue
}

type SetQueryType = <T>(queryKey: QueryKey) => (data: T) => T | undefined

export const useSetQueryState: SetQueryType = (queryKey) => {
  const queryClient = useQueryClient()
  return (data) => queryClient.setQueryData(queryKey, data, { updatedAt: new Date().getTime() })
}

export const useRemoveQueryState = (queryKey: QueryKey) => {
  const queryClient = useQueryClient()

  return () => queryClient.setQueryData(queryKey, undefined, { updatedAt: new Date().getTime() })
}

export const useResetCache = () => {
  const queryClient = useQueryClient()

  return () => queryClient.clear()
}
